import { type Session } from "@decentriq/core";
import { useCallback, useMemo } from "react";
import {
  MediaDataRoomJobInput,
  useMediaDataRoomJob,
} from "features/mediaDataRoom/hooks/ab";
import { type PublishedDatasetsHashes } from "features/mediaDataRoom/models";
import { type DataAttributesHookResult } from "../models";
import { transformDataAttributes } from "./utils";

interface DataAttributesHookPayload {
  dataRoomId: string;
  driverAttestationHash: string;
  publishedDatasetsHashes: PublishedDatasetsHashes;
  session?: Session;
  getScopeId: () => Promise<string>;
  skip: boolean;
}

export const useDataAttributes = ({
  dataRoomId,
  driverAttestationHash,
  getScopeId,
  publishedDatasetsHashes,
  session,
  skip,
}: DataAttributesHookPayload): DataAttributesHookResult => {
  const customDatasetsHashes = useMemo(
    () => publishedDatasetsHashes,
    // Data attributes computation depends only on demographics & segments datasets so only that used for caching
    // TODO: uncomment when issue with jobs resolved
    // .updateAudiencesDatasetHash(null)
    // .updateDatasetsHash(
    //   publishedDatasetsHashes.hasRequiredData
    //     ? {
    //         demographicsDatasetHash:
    //           publishedDatasetsHashes.publisherDatasetsHashes
    //             .demographicsDatasetHash ?? "",
    //         segmentsDatasetHash:
    //           publishedDatasetsHashes.publisherDatasetsHashes
    //             .segmentsDatasetHash ?? "",
    //       }
    //     : null
    // ),
    [publishedDatasetsHashes]
  );
  return useMediaDataRoomJob({
    getScopeId,
    input: MediaDataRoomJobInput.create(
      "getDataAttributes",
      dataRoomId,
      driverAttestationHash,
      customDatasetsHashes
    ),
    requestCreator: useCallback(
      (dataRoomIdHex, scopeIdHex) => ({
        dataRoomIdHex,
        scopeIdHex,
      }),
      []
    ),
    session,
    skip,
    transform: transformDataAttributes,
  });
};

export default useDataAttributes;
